import "./splitPane.less";

import React from "react";
import ReactSplitPane from "react-split-pane";
import Pane from "react-split-pane/lib/Pane";
import { observable } from "mobx";
import { observer } from "mobx-react";

interface SplitPaneProps {
  onDragEnd?: (firstSize: number) => void;
}

@observer
export class SplitPane extends React.Component<SplitPaneProps> {
  @observable sizes: string[] = ["", ""];
  render() {
    return (
      <ReactSplitPane
        className="SplitPane"
        split="vertical"
        onChange={(sizes: string[]) => {
          this.sizes = sizes;
        }}
      >
        <Pane className="pane" size={this.sizes[0]}>
          {this.props.children[0]}
        </Pane>
        <Pane
          size={this.sizes[1]}
          className="pane"
          minSize="360px"
          maxSize="650px"
          initialSize="650px"
        >
          {this.props.children[1]}
        </Pane>
      </ReactSplitPane>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/components/splitPane/splitPane.tsx